<template>
<div class="drawerWrap devDetailDW">
   <div class="drawerBody detailsDrawerBody">
      <div class="basic detailsItem">
         <h4>基本信息</h4>
         <div class="details">
            <ul>
               <li>
                  <div class="label">设备类型名称:</div>
                  <div class="value">{{datailsData.name}}</div>
               </li>
               <li>
                  <div class="label">设备注册至:</div>
                  <div class="value">{{datailsData.registTo==0?'XY':'LT'}}</div>
               </li>
               <li>
                  <div class="label">设备心跳周期:</div>
                  <div class="value">{{datailsData.heartBeat}} S</div>
               </li>
                <li>
                  <div class="label">设备报警时间间隔:</div>
                  <div class="value">{{datailsData.alarmInterval}} S</div>
               </li>
               <li>
                  <div class="label">通信协议方式:</div>
                  <div class="value">{{datailsData.protocol==1?'TCP':'UDP'}}</div>
               </li>
               <li>
                  <div class="label">启用方式:</div>
                  <div class="value">{{datailsData.isEnabled?'启用':'禁用'}}</div>
               </li>
               <li>
                  <div class="label">创建时间:</div>
                  <div class="value">{{datailsData.createTime}}</div>
               </li>
            </ul>
         </div>
      </div>
   </div>
</div>
</template>

<script>
export default {
   props: {
      datailsData: {
         type: Object,
         default: () => {
            return {};
         }
      }
   },
   data() {
      return {

      };
   },
   watch: {
      datailsData(newV) {
         console.log(newV);

      }
   },
   created() {
      console.log(this.datailsData)

   },
   mounted() {
      
   },
   methods: {

   }
};
</script>

<style lang="scss" scoped>
.detailsDrawerBody {
   padding: 10px 35px;

   .detailsItem {
      padding-left: 20px;

      h4 {
         font-size: 16px;
         color: #333;
         line-height: 38px;
         font-weight: bold;
         border-bottom: 1px solid #aaa;
      }

      .details {
         padding: 10px 0;

         ul {

            li {
               line-height: 38px;

               .label {
                  display: inline-block;
                  vertical-align: middle;
                  color: #bbb;
                  width: 120px;
               }

               .value {
                  display: inline-block;
                  vertical-align: middle;
                  color: #888;
                  margin-left: 5px;

                  .unit {
                     margin-left: 10px;
                  }
               }
            }
         }

         .btn {
            position: absolute;
            right: 20px;
            top: 50%;
            margin-top: -20px;
         }
      }

      &.params {
         .details {
            padding-right: 100px;
            position: relative;
         }
      }

   }

}
</style>